import * as emsConfigs from './configs/emsSubjectConfigs';
import * as mtConfigs from './configs/mtSubjectConfigs';
import * as shsConfigs from './configs/shsSubjectConfigs';

const KINDER_TEMPLATES = new Set([
   'prekinder',
   'kinder',
   'kindergarten',
   'kindergarten 1',
   'kindergarten 2',
   'casa',
   'casa am',
   'casa pm',
   'advance casa',
   'senior casa',
   'junior casa'
]);

const EMS_GRADE_SUFFIX = {
   'grade 1': '1',
   'grade 2': '2',
   'grade 3': '3',
   'grade 4': '4',
   'grade 5': '5',
   'grade 6': '6',
   'grade 7': '7',
   'grade 8': '8',
   'grade 9': '9',
   'grade 10': '10'
};

const MT_GRADE_CODE = {
   'grade 1': 'G1',
   'grade 2': 'G2',
   'grade 3': 'G3',
   'grade 4': 'G4',
   'grade 5': 'G5',
   'grade 6': 'G6',
   'grade 7': 'G7',
   'grade 8': 'G8',
   'grade 9': 'G9',
   'grade 10': 'G10'
};

const SHS_SUBJECT_PREFIX = {
   ae: 'AEG12',
   bc: 'BC',
   besr: 'BESRG12',
   bf: 'BFG12',
   bm: 'BM',
   cesc: 'CESC',
   chem1: 'CHEM1',
   chem2: 'CHEM2',
   cn: 'CN',
   cw: 'CWG12',
   diass: 'DIASS12',
   drr: 'DRR',
   dss: 'DSS',
   els: 'ELS',
   fabm1: 'FABM1',
   fabm2: 'FABM2G12',
   gb1: 'GB1G12',
   gb2: 'GB2G12',
   gp1: 'GP1G12',
   gp2: 'GP2G12',
   oc: 'OCG11',
   om: 'OM12',
   pc: 'PC',
   pm: 'PM',
   ppg: 'PPGG12',
   ps: 'PS',
   raw: 'RAW',
   stats: 'SP',
   sp: 'SP',
   tnct: 'TNCTG12',
   wrbs: 'WRBSG12',
   gm: 'GMG11',
   gs: 'GSG11',
   lcs: 'LCSG11',
   mk: 'MKG11',
   pklp: 'KPG11',
   ec: 'ECG11',
};

const MT_SUBJECT_SET = new Set(['mtlang', 'mtmath', 'mtsci', 'mtral', 'mteng']);
const EMS_SUBJECT_SET = new Set(['english', 'math', 'science', 'ems']);

function normalize(value) {
   return (value || '').toString().trim().toLowerCase();
}

function getEMSGradeSuffix(template) {
   const normalizedTemplate = normalize(template);

   if (KINDER_TEMPLATES.has(normalizedTemplate)) {
      return 'K';
   }

   return EMS_GRADE_SUFFIX[normalizedTemplate] || null;
}

function getMTGradeCode(template) {
   const normalizedTemplate = normalize(template);

   if (KINDER_TEMPLATES.has(normalizedTemplate)) {
      return 'K';
   }

   return MT_GRADE_CODE[normalizedTemplate] || null;
}

export function resolveEMSIndividualConfig(template, subjectId) {
   const gradeSuffix = getEMSGradeSuffix(template);
   const normalizedSubject = normalize(subjectId);

   if (!gradeSuffix || !['english', 'math', 'science'].includes(normalizedSubject)) {
      return null;
   }

   const key = `${normalizedSubject.toUpperCase()}${gradeSuffix}_SUBJECT_CONFIG`;
   return emsConfigs[key] || null;
}

export function resolveEMSSummaryConfig(template) {
   const gradeSuffix = getEMSGradeSuffix(template);

   if (!gradeSuffix) {
      return null;
   }

   const english = emsConfigs[`ENGLISH${gradeSuffix}_SUBJECT_CONFIG`];
   const math = emsConfigs[`MATH${gradeSuffix}_SUBJECT_CONFIG`];
   const science = emsConfigs[`SCIENCE${gradeSuffix}_SUBJECT_CONFIG`];

   if (!english || !math || !science) {
      return null;
   }

   return { english, math, science };
}

export function resolveMTConfig(template, subjectId) {
   const gradeCode = getMTGradeCode(template);
   const normalizedSubject = normalize(subjectId);

   if (!gradeCode || !MT_SUBJECT_SET.has(normalizedSubject)) {
      return null;
   }

   if (gradeCode === 'K') {
      const mtKinderKeyMap = {
         mtlang: 'MTKLANGUAGE_SUBJECT_CONFIG',
         mtmath: 'MTKMATH_SUBJECT_CONFIG',
         mtsci: 'MTKSCIENCE_SUBJECT_CONFIG'
      };

      return mtConfigs[mtKinderKeyMap[normalizedSubject]] || null;
   }

   const mtGradeSubjectMap = {
      mtlang: 'LANGUAGE',
      mtral: 'RAL',
      mtmath: 'MATH',
      mteng: 'ENGLISH',
      mtsci: 'SCIENCE'
   };

   const subjectKey = mtGradeSubjectMap[normalizedSubject];
   if (!subjectKey) {
      return null;
   }

   const key = `MT${gradeCode}${subjectKey}_SUBJECT_CONFIG`;
   return mtConfigs[key] || null;
}

export function resolveSHSConfig(template, subjectId) {
   // const normalizedTemplate = normalize(template);
   const normalizedSubject = normalize(subjectId);

   // if (normalizedSubject === 'raw') {
   //    if (normalizedTemplate === 'grade 11') {
   //       return shsConfigs.RAWG11_SUBJECT_CONFIG || null;
   //    }

   //    if (normalizedTemplate === 'grade 12') {
   //       return shsConfigs.RAWG12_SUBJECT_CONFIG || null;
   //    }
   // }

   const prefix = SHS_SUBJECT_PREFIX[normalizedSubject];
   if (!prefix) {
      return null;
   }

   return shsConfigs[`${prefix}_SUBJECT_CONFIG`] || null;
}

export function getReportFamily(template, subjectId) {
   const normalizedTemplate = normalize(template);
   const normalizedSubject = normalize(subjectId);

   if (MT_SUBJECT_SET.has(normalizedSubject)) {
      return 'mt';
   }

   if (KINDER_TEMPLATES.has(normalizedTemplate) || EMS_GRADE_SUFFIX[normalizedTemplate] || EMS_SUBJECT_SET.has(normalizedSubject)) {
      return 'ems';
   }

   return 'shs';
}
